import { Component, Injector } from '@angular/core';
import { IWebsiteConstants } from '@lmnop/web-core';

import { NgxSpinnerService } from 'ngx-spinner';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'subscribe-wecdev-control',
    templateUrl: './subscribe-wecdev.control.html',
    styleUrl: 'subscribe-wecdev.control.scss',
    standalone: false,
})
export class SubscribeWecdevControl extends ControlBase {
    constructor(
        protected injector: Injector,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
        let websiteConstants: IWebsiteConstants = this.ioc.core.websiteConstants;

        this.twitterUrl = new URL('wecdevcom', websiteConstants.twitter.FULL_MAIN_DOMAIN_URL).toString();
        this.facebookUrl = new URL('Wecdevcom', websiteConstants.facebook.FULL_MAIN_DOMAIN_URL).toString();
    }

    public twitterUrl: string;
    public facebookUrl: string;
}
